import { LockOutlined, UserOutlined } from "@ant-design/icons"
import { unwrapResult } from "@reduxjs/toolkit"
import { Button, Col, Form, Input, notification, Row } from "antd"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useHistory } from "react-router"
import { CREDENTIALS_KEY, setCredentials } from "../../app/appSlice"
import { useAppDispatch } from "../../app/hooks"
import { ThemeContext } from "../../theme/theme"
import { atLeast, useQuery } from "../../utils/system"
import BackgroundImage from "./assets/background.jpg"
import BannerImage from "./assets/banner.png"
import styles from "./Login.module.css"
import { login, ssoLogin } from "./loginSlice"

export const Login = (): ReactElement => {
  const dispatch = useAppDispatch()

  const query = useQuery()

  const history = useHistory()

  const theme = useContext(ThemeContext)

  const [isLoading, setIsLoading] = useState(false)

  const [isSsoMode, setIsSsoMode] = useState(true)

  useEffect(() => {
    const accessToken = query.get("access_token")
    console.log(query)
    if (accessToken) {
      dispatch(ssoLogin(accessToken))
        .then(unwrapResult)
        .then((data) => {
          dispatch(
            setCredentials({
              userId: data.userId,
              userName: data.userName,
              token: data.accessToken,
              regionName: data.regionName,
              regionCode: data.regionCode,
              roleType: data.roleType,
            })
          )
          history.replace({
            pathname: "/",
          })
        })
        .catch((e: any) => {
          notification.error({
            message: e.message,
            duration: 3,
          })
        })
    } else {
      setIsSsoMode(false)
    }
  }, [dispatch, query])

  return (
    <>
      <img
        src={BackgroundImage}
        alt='登录页面背景图'
        style={{
          width: "100vw",
          height: "100vh",
          objectFit: "cover",
        }}
      />
      <Row
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        wrap={false}
        align='middle'
      >
        <Col style={{ width: 700, height: 700 }}>
          <img
            src={BannerImage}
            alt='欢迎图'
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Col>
        <Col
          style={{
            width: 560,
            height: 640,
            paddingTop: 120,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
            borderRadius: "0 4px 4px 0",
          }}
        >
          <div style={{ color: theme.c1, fontSize: 28, fontWeight: "bold" }}>
            诊疗行为监督在线
          </div>
          <Form
            autoComplete='off'
            requiredMark={false}
            colon={false}
            size='large'
            className={styles.form}
            style={{ width: 400, marginTop: 100 }}
            onFinish={async (values) => {
              try {
                setIsLoading(true)
                await atLeast(1000, async () => {
                  const result = await dispatch(login(values)).then(
                    unwrapResult
                  )
                  dispatch(
                    setCredentials({
                      userId: result.userId,
                      userName: result.userName,
                      token: result.accessToken,
                      regionName: result.regionName,
                      regionCode: result.regionCode,
                      roleType: result.roleType,
                    })
                  )
                  window.location.href = "/"
                })
              } catch {
                setIsLoading(false)
              }
            }}
          >
            <Form.Item
              name='username'
              label={
                <UserOutlined style={{ fontSize: 24, color: theme.tc1 }} />
              }
              rules={[{ required: true, message: "请输入用户名" }]}
              style={{ marginBottom: 60 }}
            >
              <Input allowClear />
            </Form.Item>
            <Form.Item
              name='password'
              label={
                <LockOutlined style={{ fontSize: 24, color: theme.tc1 }} />
              }
              rules={[{ required: true, message: "请输入密码" }]}
            >
              <Input.Password />
            </Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              disabled={isSsoMode}
              loading={isLoading}
              style={{ marginTop: 70, width: "100%" }}
            >
              登录
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  )
}
